import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource/poppins/latin-400.css'
import '@fontsource/poppins/latin-500.css'
import '@fontsource/poppins/latin-600.css'
import '@fontsource/poppins/latin-700.css'
import '@fontsource/poppins/latin-800.css'
import '@fontsource/poppins/latin-900.css'
import './index.css'
import App from './App.jsx'
import StartupReady from './components/public/StartupReady.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <StartupReady />
    <App />
  </StrictMode>,
)
